export default function readTextFile(file: File): Promise<string> {
  return new Promise((resolve: (string) => void, reject) => {
    const reader = new FileReader()
    reader.readAsText(file)
    reader.onload = (ev: any) => {
      const text = ev.target.result as string
      resolve(text)
    }
    reader.onerror = (ev: any) => reject(ev.target.error as Error)
  })
}
